<script lang="ts" setup>
const toastStore = useToastStore()

const isPageRefreshed = ref(false)
const isToastVisible = computed(
  () => toastStore.isToastOpen && !isPageRefreshed.value,
)

const { data } = await useFetch('/api/careers/postings')
const { story } = await useFetchStory('careers')

onMounted(() => {
  const navigationEntry = window.performance.getEntriesByType(
    'navigation',
  )[0] as PerformanceNavigationTiming
  if (navigationEntry) {
    isPageRefreshed.value =
      navigationEntry.type === 'reload' ||
      navigationEntry.type === 'back_forward'
  }
  if (isToastVisible.value) {
    setTimeout(() => {
      toastStore.toggleToast(false)
    }, 4000)
  }
})

useCustomHead(story)
false && /*#__PURE__*/ defineI18nRoute({
  locales: ['en'],
})

const { layoutName, layoutNavbarColor, layoutFooterColor } =
  useLayout<any>(story)
</script>

<template>
  <NuxtLayout
    :name="layoutName"
    :navbar-color="layoutNavbarColor"
    :footer-color="layoutFooterColor"
  >
    <div v-if="story" :id="story.name.toLowerCase()" class="careers">
      <BaseToast
        v-if="isToastVisible"
        :icon="'icon-error'"
        :bg-color="'#FF8370'"
      >
        Oops! This role is no longer available. Scroll down to see our current
        open positions.
      </BaseToast>
      <StoryblokComponent
        v-for="component in story.content.hero"
        :key="component.uid"
        :blok="component"
      />
      <LazyCareersPositions v-if="data" :data="data" />
      <StoryblokComponent
        v-for="component in story.content.body"
        :key="component.uid"
        :blok="component"
      />
    </div>
  </NuxtLayout>
</template>
